const baseUrl = 'https://madstackinnovation.com/api';

export default baseUrl;
